var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu24Dp434343Fill0Wght400Grad0Opsz48 = function SvgMenu24Dp434343Fill0Wght400Grad0Opsz48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    fill: "#434343"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120-240v-60h720v60H120Zm0-210v-60h720v60H120Zm0-210v-60h720v60H120Z"
  })));
};
export default SvgMenu24Dp434343Fill0Wght400Grad0Opsz48;